import { Base } from "../core/base.model";


export class TamanioCliente extends Base {

    public id: number;
	public de:number;
	public al:number;
	public estatus:string;

}

